module.exports = vant;


//////////////////
// WEBPACK FOOTER
// external "vant"
// module id = 127
// module chunks = 140